export const BASEURL = "https://api-dharma.gokozo.com";
export const ORG_LOGO = `${BASEURL}/uploads/primary-logo.png`;